import React, { useState, useEffect } from "react";
import { FiChevronDown } from "react-icons/fi";
import OutsideClickHandler from "react-outside-click-handler";

import { getAvatarUrl } from "src/Common/common";

const TechDropdown = ({ options = [], selectedTech, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [techArray, setTechArray] = useState(options);

  useEffect(() => {
    setTechArray(options);
  }, [options]);

  const handleTechClick = (option) => {
    setIsOpen(false);
    setKeyword("");
    onSelect(options.indexOf(option));
  };

  const keywordChanged = (value) => {
    setKeyword(value);
    if (value.length === 0) {
      setTechArray(options);
      return;
    }

    const lowerKeyword = value.toLowerCase();
    setTechArray(
      options.filter((option) => (option?.name || "").toLowerCase().includes(lowerKeyword))
    );
  };

  return (
    <OutsideClickHandler
      onOutsideClick={() => {
        setIsOpen(false);
      }}
    >
      <div className="relative w-full">
        <div
          onClick={(e) => {
            setIsOpen(true);
          }}
          className="w-full flex items-center h-[30px] justify-between px-4 py-2 border rounded-[6px] text-gray-800 focus:outline-none focus:border-blue-500 cursor-pointer"
        >
          {/* <span className="font-OpenSansRegular text-[400] text-[12px] text-titleColor">{defaultOption}</span> */}
          <div>
            {selectedTech ? (
              <div className=" py-2 cursor-pointer flex gap-3 items-center">
                <img src={getAvatarUrl(selectedTech.avatar)} className="w-[15px] h-[15px] rounded-[7.5px]" />
                <span className="font-OpenSansRegular text-[12px]">{selectedTech.name}</span>
              </div>
            ) : (
              <span className="font-OpenSansRegular text-[12px]">Select</span>
            )}
          </div>
          <FiChevronDown className="ml-2" size={15} />
        </div>
        {isOpen && (
          <ul className="absolute z-10 mt-2 w-full bg-white border rounded-md shadow-lg max-h-[300px] overflow-y-auto">
            <li className="px-4 py-1 cursor-pointer flex gap-3 items-center border-b-[1px] border-borderColor">
              <input
                value={keyword}
                onChange={(e) => keywordChanged(e.target.value)}
                className="w-full h-[30px] font-OpenSansRegular text-[12px]"
                placeholder="Search technician"
              />
            </li>
            {techArray.map((option, index) => (
              <li
                key={index}
                onClick={() => handleTechClick(option)}
                className="px-4 py-2 cursor-pointer hover:bg-gray-200 flex gap-3 items-center"
              >
                <img src={getAvatarUrl(option.avatar)} className="w-[15px] h-[15px] rounded-[7.5px]" />
                <span className="font-OpenSansRegular text-[12px]">{option.name}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </OutsideClickHandler>
  );
};

export default TechDropdown;
